module.exports = __webpack_public_path__ + "img/vicenya.a8740b4a.jpg";